import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import { formatMonto } from "@/utils";
export default [
  {
    prop: "DealsId",
    label: "NO",
    width: 70,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "CompanyName",
    label: "Cliente",
    minWidth: 250
  },
  {
    prop: "DealDescription",
    label: "Negociación",
    minWidth: 300
  },
  {
    prop: "TypeUser",
    label: "Tipo",
    align: "center",
    width: 180,
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "TotalAmount",
    label: "Monto total",
    width: 130,
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "Clasificacion",
    label: "Clasificacion",
    align: "center",
    width: 130,
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "Quantity",
    label: "Cantidad",
    width: 110,
    sortable: true
  },
  {
    prop: "UnitPrice",
    label: "P. Unitario",
    width: 120,
    formatter: (row) => formatMonto(row.UnitPrice)
  },
  {
    prop: "ProductName",
    label: "Producto",
    minWidth: 120
  },
  {
    label: "Contacto",
    prop: "ContactName",
    minWidth: 200
  },
  {
    prop: "Currency.Name",
    label: "Moneda",
    width: 100
  },
  {
    prop: "DaysLate",
    label: "Dias abierta",
    //formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "DayOnPhase",
    label: "Días en etapa",
    //formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "InitialDate",
    label: "Fecha de creacion",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "FinalDate",
    label: "Fecha de cierre",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "LastUpdatedAt",
    label: "Fecha de Fase",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "SalesPersonName",
    label: "Vendedor",
    formatter: ImagePerson,
    minWidth: 220,
    attrs: {
      imgKey: "SalesPersonPhoto"
    }
  },
  {
    prop: "CreatedPersonName",
    label: "Creador",
    formatter: ImagePerson,
    minWidth: 250,
    attrs: {
      imgKey: "CreatedPersonPhoto"
    }
  },
  {
    label: "Sop. Ventas",
    prop: "SupportSellerName",
    minWidth: 250,
    formatter: ImagePerson,
    attrs: {
      imgKey: "SupportSellerPhoto"
    }
  },
  {
    label: "Razón de Perdida",
    prop: "Reason",
    minWidth: 200,
    formatter: (row) => row.Reason && row.Reason.substring(0, 50) + "..."
  },
  {
    label: "¿Que pude hacer mejor?",
    prop: "question1",
    minWidth: 200,
    formatter: (row) => row.question1 && row.question1.substring(0, 50) + "..."
  },
  {
    label: "¿En que no me ayudo la empresa?",
    prop: "question2",
    minWidth: 200,
    formatter: (row) => row.question2 && row.question2.substring(0, 50) + "..."
  }
];
